import { HERO_CAROUSEL } from '../constants/home'
import { useAutoCarousel } from './useAutoCarousel'

/** Hero banner carousel — thin wrapper around shared autoplay carousel. */
export function useHeroCarousel(slideCount: number) {
  return useAutoCarousel(slideCount, HERO_CAROUSEL.autoplayMs)
}
